import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Contract } from 'src/app/lib/contract/classes';
import { IssueItem } from '../../../classes';

@Component({
  selector: 'app-issue-item-contract-label',
  templateUrl: './issue-item-contract-label.component.html',
  styleUrls: ['./issue-item-contract-label.component.css'],
  animations: [
    trigger('slideIn', [
      transition(
        ':enter', 
        [
          style({ height: 0}),
          animate('.2s ease-out', style({ height: '*' }))
        ]
      ),
      transition(
        ':leave', 
        [
          style({ height: '*' }),
          animate('.2s ease-in', style({ height: 0 }))
        ]
      )
    ])
  ]
})
export class IssueItemContractLabelComponent implements OnInit {

  @Input() contracts: Contract[] = [];

  _item: IssueItem;
  @Input() set item(item: IssueItem){
    this._item = item;
    if(item) this.selectedContract = item.itemcontract;
  }
  get item(): IssueItem {
    return this._item;
  }

  @Input() detailsExpanded: boolean = false;
  @Output() selectedContractChanged: EventEmitter<number> = new EventEmitter();

  _selectedContract: number;
  set selectedContract(value: number){
    this._selectedContract = value;
    if(value) this.selectedContractChanged.emit(value);
  }
  get selectedContract(): number {
    return this._selectedContract;
  }

  constructor() { }

  ngOnInit(): void {
  }

}
